import { TXTResult, Item, Fatura, EnvelopeEDI } from "../../totvs-easy/leitura/utils/processTXTFile";

export const processMartinsLogEDI = (rawText: string): TXTResult => {

  const linhas = rawText.split(/\r?\n/).map(s => s.trim()).filter(s => s.length > 0);
  const faturas: { [key: string]: Fatura } | any = {};

  let envelopeEdi: EnvelopeEDI = {};
  let faturaAtual: string | null = null;
  let currentItem: Item | null = null;

  linhas.forEach((linha, index) => {
    const partes = linha.split(/[\x1C-\x1F*|]/).map(p => p.trim());
    const tag = partes[0].toUpperCase().replace(/[^A-Z0-9]/g, '');

    switch (tag) {
      case 'ISA':
        envelopeEdi.isaSenderQualifier = partes[5]?.trim();
        envelopeEdi.isaSenderId = partes[6]?.trim();
        envelopeEdi.isaReceiverQualifier = partes[7]?.trim();
        envelopeEdi.isaReceiverId = partes[8]?.trim();
        envelopeEdi.isaControlNumber = partes[13]?.trim();
        break;

      case 'GS':
        envelopeEdi.gsSenderId = partes[2]?.trim();
        envelopeEdi.gsReceiverId = partes[3]?.trim();
        envelopeEdi.gsControlNumber = partes[6]?.trim();
        break;

      case 'BIG':
        // Nova fatura!
        const dataProcesso = partes[1]; 
        const numeroFatura = partes[2]; 
        faturaAtual = numeroFatura;

        faturas[faturaAtual] = {
          numeroDaFatura: numeroFatura,
          dataDoProcesso: dataProcesso,
          itens: []
        };
        
        currentItem = null; 
        break;

      case 'CUR':
        if (faturaAtual && faturas[faturaAtual]) {
          faturas[faturaAtual].moedaNegociada = partes[2];
          faturas[faturaAtual].siglaMoedaNegociada = partes[2];
        }
        break;

      case 'N1':
        if (faturaAtual && faturas[faturaAtual] && (partes[1] === 'BY' || partes[1] === 'II' || partes[1] === 'IM')) {
          faturas[faturaAtual].codigoImportador = partes[2]; 
        }
        break;

      case 'IT1':
        if (faturaAtual && faturas[faturaAtual]) {

          let ncmExtraido = '';
          const indiceHD = partes.indexOf('HD');
          if (indiceHD !== -1 && partes.length > indiceHD + 1) {
            ncmExtraido = partes[indiceHD + 1];
          }

          currentItem = {
            quantidade: partes[2], 
            valorUnitario: partes[4], 
            codigoDoProduto: partes[7],
            descricaoDetalhadaDaMercadoria: '',
            ncmSh: ncmExtraido,
            serialNumbers: []
          };

          if (!faturas[faturaAtual].itens) {
            faturas[faturaAtual].itens = [];
          }
          faturas[faturaAtual].itens.push(currentItem);
        }
        break;
      
      case 'MEA':
        if (partes[1] === 'WT') {
          if (partes[2] === 'G') {
            if (faturaAtual && faturas[faturaAtual]) {
              faturas[faturaAtual].pesoBruto = partes[3];
            }
          } else if (partes[2] === 'N') {
            if (currentItem) {
              currentItem.pesoLiquido = partes[3];

              // --- Calcula o Peso Líquido Unitário ---
              // const pesoTotalStr = partes[3] ? partes[3].replace(',', '.') : '0';
              // const quantidadeStr = currentItem.quantidade ? currentItem.quantidade.replace(',', '.') : '1';

              // const pesoTotalFloat = parseFloat(pesoTotalStr) || 0;
              // const quantidadeFloat = parseFloat(quantidadeStr) || 1;

              // const pesoUnitarioFloat = pesoTotalFloat / quantidadeFloat;

              // currentItem.pesoLiquidoUni = pesoUnitarioFloat.toFixed(5);
            }
          }
        }
        break;
      
      case 'PID':
        if (currentItem && partes[1] === 'F') {
          currentItem.descricaoDetalhadaDaMercadoria = partes[5] || partes.slice(5).join(' ');
        }
        break;

      case 'REF':
        const limpos = partes.map(p => p.toUpperCase().replace(/[^A-Z0-9]/g, ''));

        if (limpos.includes('ZZ') && faturaAtual && faturas[faturaAtual]) {
           const idx = limpos.indexOf('ZZ');
           faturas[faturaAtual].codigoUrfEntrada = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
        } else if (currentItem) {
           
           // Tratamento de Serial Separado
           if (limpos.includes('SE')) {
             const idx = limpos.indexOf('SE');
             const numeroSerie = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
             
             if (numeroSerie) {
                if (!currentItem.serialNumbers) {
                    currentItem.serialNumbers = [];
                }
                currentItem.serialNumbers.push(numeroSerie);
             }
           } 
           
           // Tratamento do Número do Pedido (DO)
           if (limpos.includes('DO')) {
             const idx = limpos.indexOf('DO');
             currentItem.numeroDoPedido = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
           } 
           
           // Tratamento da Ordem de Compra (PO)
           if (limpos.includes('PO')) {
             const idx = limpos.indexOf('PO');
             currentItem.numeroOrdemCompra = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
           } 
           
           // Tratamento da Sequência da Ordem de Compra (LI)
           if (limpos.includes('LI')) {
             const idx = limpos.indexOf('LI');
             currentItem.sequenciaOrdemCompra = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
           } 
           
           // Tratamento da Sequência do Pedido
           if (currentItem.numeroDoPedido) {
             const pedidoLimpo = currentItem.numeroDoPedido.toUpperCase().replace(/[^A-Z0-9]/g, '');
             if (limpos.includes(pedidoLimpo)) {
               const idx = limpos.indexOf(pedidoLimpo);
               currentItem.sequenciaItemDoProcesso = partes[idx + 1] ? partes[idx + 1].replace(/~/g, '') : '';
             }
           }
        }
        break;

      case 'SAC':
        if (currentItem && partes[2] === 'I132') {
           currentItem.valorTotal = partes[5];
        }
        break;

      case 'TDS':
        if (faturaAtual && faturas[faturaAtual]) {
           faturas[faturaAtual].valorMle = partes[1];
        }
        break;
    }
  });

  console.log(`Leitura concluída! Total de Faturas encontradas: ${Object.keys(faturas).length}`);
  console.log("Cabeçalho EDI extraído:", envelopeEdi);
  console.log("Objeto Final estruturado:", faturas);

  return {
    faturas: faturas,
    envelopeEdi: envelopeEdi
  };
};